import { render, staticRenderFns } from "./GSATPreExam.vue?vue&type=template&id=5db455b4&scoped=true&lang=pug&"
import script from "./GSATPreExam.vue?vue&type=script&lang=js&"
export * from "./GSATPreExam.vue?vue&type=script&lang=js&"
import style0 from "./GSATPreExam.vue?vue&type=style&index=0&id=5db455b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db455b4",
  null
  
)

export default component.exports